<template>
  <div class="w-full">
    <AccordionItemHTML v-for="(item, index) in items" :key="index" :item="item" />
  </div>
</template>

<script>
import AccordionItemHTML from './AccordionItemHtml.vue'
export default {
  props: ['items'],
  components: {
    AccordionItemHTML
  },
  data(){
    return {

    }
  }
}
</script>